import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import MediaQuery from 'react-responsive';
import Avatar from '../../../../../../components/Avatar';
import Collapsable from '../../../../../../components/Collapsable';
import LinkButton from '../../../../../../components/LinkButton';
import ReadMore from '../../../../../../components/ReadMore';
import {MESSAGE_TYPE} from '../../../../../../constants/message-types';
import ROUTE from '../../../../../../constants/route';
import LinkBuilder from '../../../../../../helpers/link-builder';
import InboxItemAttachments from '../InboxItemAttachments/InboxItemAttachments';
import InboxItemTo from '../InboxItemTo';

const InboxItemTypeSent = props => {
  const { user, message, hasHTML } = props;

  const {
    MessageID,
    FromName,
    Subject,
    Date,
    Type,
    Text,
    File,
    ReviewType,
    ToPictureUrl,
    Attachments,
  } = message;

  const avatar = ReviewType
    ? null
    : LinkBuilder.getCandidatePictureSizeLink(ToPictureUrl, '60x60');

  const attachments = useMemo(() => {
    if (Attachments && Attachments.length > 0) {
      return Attachments.map(attach => ({
        name: attach.Name,
        link: LinkBuilder.getInboxAttachedFileLink(
          attach.Name,
          attach.MessageID,
          attach.id
        ),
      }));
    }

    return File
      ? [
          {
            name: File,
            link: LinkBuilder.getInboxAttachedFileLink(File, MessageID),
          },
        ]
      : null;
  }, [File, Attachments]);

  return (
    <div className="inbox-item__container">
      <MediaQuery query="(max-width: 767px)">
        <div className="inbox-item__direction"> To: </div>
        <div className="inbox-item__top">
          <div className="inbox-item__avatar">
            <Avatar size={60} name={FromName} image={avatar} />
          </div>
          <div className="inbox-item__person">
            <InboxItemTo user={user} message={message} />
          </div>
        </div>
      </MediaQuery>

      <MediaQuery query="(min-width: 768px)">
        <div className="inbox-item__avatar">
          <Avatar size={60} name={FromName} image={avatar} />
        </div>
      </MediaQuery>

      <div className="inbox-item__content">
        <div className="inbox-item__row">
          <div className="inbox-item__meta">
            <MediaQuery query="(min-width: 768px)">
              <div className="inbox-item__direction"> To: </div>
              <div className="inbox-item__person">
                <InboxItemTo user={user} message={message} />
              </div>
            </MediaQuery>
          </div>
          <div className="inbox-item__status inbox-item__status--received">
            SENT
          </div>
        </div>

        <div className="inbox-item__row">
          <div className="inbox-item__subject">{Subject}</div>
        </div>
        <div className="inbox-item__row">
          <div className="inbox-item__date">{Date}</div>
        </div>

        <div className="inbox-item__text">
          {hasHTML ? (
            <Collapsable
              btnHidden={
                Text.length < 400 && Text.split(/\r\n|\r|\n/).length <= 5
              }
              maskHidden={
                Text.length < 400 && Text.split(/\r\n|\r|\n/).length <= 5
              }
            >
              <div dangerouslySetInnerHTML={{ __html: Text }} />
            </Collapsable>
          ) : (
            <ReadMore text={Text} readMoreCharacterLimit={120} />
          )}
          {Type === MESSAGE_TYPE.TYPE_CONNECT_ACCEPT && (
            <div>
              You can review all your connections here:{' '}
              <LinkButton
                btnFontWeight={400}
                to={ROUTE.MY_NETWORK}
                text="My Network"
              />
            </div>
          )}
        </div>
        {attachments && <InboxItemAttachments attachments={attachments} />}
      </div>
    </div>
  );
};

InboxItemTypeSent.propTypes = {
  user: PropTypes.object.isRequired,
  message: PropTypes.object.isRequired,
  hasHTML: PropTypes.bool,
};

export default InboxItemTypeSent;
